'use client';

import V2Layout from './v2/V2Layout';

/**
 * LayoutWrapper - thin shell that owns the v2 page chrome.
 *
 * Every active page on the prostay-website-v2 branch has been migrated to
 * the v2 design system, so we wrap *everything* (including the locale-scoped
 * 404 page rendered via app/[locale]/[...rest]/not-found.js) in V2Layout.
 *
 * The legacy MainLayout / NotFoundContext machinery is no longer needed and
 * has been removed. Pages that want a chrome-less surface should render
 * outside LayoutWrapper (e.g. via the root app/not-found.js).
 */
export default function LayoutWrapper({ children }) {
  return <V2Layout>{children}</V2Layout>;
}
